import { use_slice_ui } from '@/hooks/store/use_slices';
import { assert_not_null } from '@shared/asserts/utils_asserts';
import { useEffect, useRef } from 'react';
import { FN_CANVAS__apply_image_compare__base } from '../_methods/FN_CANVAS__apply_image_compare__base';
import { FN_CANVAS__apply_image_compare__difference } from '../_methods/FN_CANVAS__apply_image_compare__difference';
import { PROPS__draw_mode_params } from '../_methods/PROPS__draw_mode_params';

export interface PROPS {
  image_a: HTMLImageElement;
  image_b: HTMLImageElement;
}

export function IMAGE_COMPARE__mode_difference({ image_a, image_b }: PROPS) {
  const { grid2d_image_compare__mode, grid2d_image_compare__use_image_a_asperation_ratio } = use_slice_ui([
    'grid2d_image_compare__mode',
    'grid2d_image_compare__use_image_a_asperation_ratio',
  ]);

  const ref__canvas = useRef<HTMLCanvasElement | null>(null);

  /*
   *
   */
  // Draw canvas on update
  useEffect(() => {
    const canvas: HTMLCanvasElement | null = ref__canvas.current;
    if (!canvas) return;

    const ctx = canvas.getContext('2d');
    assert_not_null(ctx);

    FN_CANVAS__apply_image_compare__base(canvas);

    const rect: DOMRect = canvas.getBoundingClientRect();

    const baseParams: PROPS__draw_mode_params = {
      ctx,
      width: rect.width,
      height: rect.height,
      image_a,
      image_b,
      fitAR: grid2d_image_compare__use_image_a_asperation_ratio,
    };

    /*
     *
     */

    FN_CANVAS__apply_image_compare__difference(baseParams);
  }, [grid2d_image_compare__mode, grid2d_image_compare__use_image_a_asperation_ratio, image_a, image_b]);

  /*
   *
   */

  return (
    <div className="relative w-full h-full rounded-lg overflow-hidden border border-[#48ff84]/20 bg-[#050906]">
      <canvas ref={ref__canvas} className="w-full h-full cursor-pointer touch-none" />
    </div>
  );
}
